export default {
    Docusign: "Docusign",
    Maintenance: "Maintenance"
}